				import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class TypePaymentSourceService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('TypePaymentSource');
	}
	
  loadAll(active: boolean) : Observable<TooBig4Car.Logic.TypePaymentSource[]> {
    return this.myBaseService.loadAll(this.url + '?active=' + (active ?? true).toString());
	}
	save(tempItem: TooBig4Car.Logic.ObjectBase) : Observable<TooBig4Car.Logic.TypePaymentSource> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<TooBig4Car.Logic.TypePaymentSource> {
		return this.myBaseService.getEdit(id, this.url);
	}
	
}
				
